import type { ComponentProps } from "react";
import { FieldGroup } from "@/shared/components/ui/FieldGroup";
import { Section } from "@/shared/components/ui/Section";
import { BusinessFields } from "./BusinessFields";

export function BusinessSection(props: ComponentProps<typeof BusinessFields>) {
  return (
    <Section title="Business details">
      <FieldGroup>
        <p className="text-sm text-muted-foreground">How your business is set up.</p>
        <BusinessFields {...props} />
      </FieldGroup>
    </Section>
  );
}